export default __webpack_public_path__ + "static/media/game.74e0f79e.png";